import React from 'react'
import { Controller, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { useAddfaq } from '../api/faqapi';
import { CircularProgress } from '@mui/material';
import PropTypes from 'prop-types';

const schema = yup.object().shape({
    question: yup.string()
        .required('Question is required'),
    answer: yup
        .string()
        .min(6, 'Answer should be atleast 6 characters.')
        .required('Answer is Required'),
})

function AddFaq({ toggle }) {
    const { control, handleSubmit, formState: { errors }, reset } = useForm({
        mode: 'onChange',
        resolver: yupResolver(schema),
        defaultValues: {
            question: '',
            answer: '',
        }
    });

    const addFaq = useAddfaq();
    const onSubmit = async (data) => {
        const res = await addFaq.mutateAsync(data)
        if (res?.status) {
            reset()
            toggle();
        }
    }

    return (
        <form onSubmit={handleSubmit(onSubmit)}>
            <div className='mb-3'>
                <h6 className="pb-2">Question</h6>
                <Controller
                    control={control}
                    name="question"
                    render={({ field }) => (
                        <input
                            {...field}
                            placeholder="Enter Question"
                            className='form-control'
                        />
                    )}
                />
                {errors.question?.message && <p className='m-0 errMsg'>{errors.question?.message}</p>}
            </div>
            <div className='mb-3'>
                <h6 className="pb-2">Answer</h6>
                <Controller
                    control={control}
                    name="answer"
                    render={({ field }) => (
                        <input
                            {...field}
                            placeholder="Enter Answer"
                            className='form-control'
                        />
                    )}
                />
                {errors.answer?.message && <p className='m-0 errMsg'>{errors.answer?.message}</p>}
            </div>
            <div className='d-flex justify-content-center rounded-pill'>
                <button className='btn btn-primary d-flex align-items-center' disabled={addFaq.isLoading}>
                    {addFaq.isLoading ?
                        <CircularProgress size={20} style={{ color: "#fff" }} className='mx-4' />
                        :
                        "Submit"}
                </button>
            </div>
        </form>
    )
}

AddFaq.propTypes = {
    toggle: PropTypes.func.isRequired,
};

export default AddFaq